export enum ROLES {
  OWNER = 'owner',
  ADMIN = 'admin',
  BASIC = 'basic',
}

export enum PERMISSIONS {
  MANAGE_WAIVERS = "manageWaivers",
  MANAGE_SHARINGS = "manageSharings",
  MANAGE_INTEGRATIONS = "manageIntegrations",
  MANAGE_LOCATIONS = "manageLocations",
  MANAGE_USERS = "manageUsers",
  MANAGE_ACTIVITY_LOG = "manageActivityLog",
  MANAGE_SUBMITS = "manageSubmits",
  MANAGE_OPENAPIS = "manageOpenapis",
  MANAGE_BILLINGS_AND_PLANS = "manageBillingsAndPlans",

  VIEW_SUBMITS = "viewSubmits",
  VIEW_SHARINGS = "viewSharings",
}
